import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'
import './customBills.scss'

export default function CustomBillsList ({
    customBills,
    pageLoading,
}) {
    const LoadingContent = () => {
        return pageLoading ? <Skeleton width={180} count={8} className="ml-28 mt-13"/> : ''
    }

    return (
        <>
            <section className="section--table custom_bills section--table">
                <div className={'section__row section__header'}>
                    <div className={'section__cell section__cell--name'}>
                        <span>Bills</span>
                    </div>
                </div>
                <div className={'section__row section__row--main'}>
                    <div className={'section__cell section__cell--name'}>
                        <div className={'title-3 section__title--spaced'}>
                            <LoadingContent/>
                            {!pageLoading && (
                                <>
                                    {customBills?.bills?.map((item) => (
                                        <Link
                                            key={item.id}
                                            to={`/bills/${item.id}`}
                                            className="link"
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}
